import { createFileRoute } from "@tanstack/react-router"
import { Campaigns } from "modules/campaigns/components/List"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { CampaignsFilterBySchema, CampaignsSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(CampaignsSortSchema.shape.sortBy.unwrap())
  .merge(CampaignsFilterBySchema)

export const Route = createFileRoute("/_base/_auth/campaigns/list")({
  component: Campaigns,
  validateSearch: (search: Partial<z.infer<typeof SearchSchema>>) => {
    search.filterBy = search.filterBy || undefined
    return SearchSchema.parse(search)
  },
})
